import { Box, Button, Divider, VStack } from '@chakra-ui/react'
import { SubTab } from '@hb/shared'

export const SidebarSubtabs = ({
  subTabs,
  selectedTab,
  onSelect,
  width = 150,
}: {
  subTabs: SubTab[]
  selectedTab: string | null
  onSelect: (tabPath: string) => void
  width?: number
}) => (
  <VStack
    borderRight="1px solid"
    borderColor="gray.200"
    h="100%"
    w={`${width}px`}
    bg="gray.100"
    spacing={0}
    divider={<Divider />}>
    {subTabs.map(subTab => (
      <Button
        variant="link"
        py={2}
        size="lg"
        w="100%"
        borderRadius={0}
        px={5}
        color={subTab.path === selectedTab ? 'gray.700' : 'gray.500'}
        bg={subTab.path === selectedTab ? 'white' : 'gray.50'}
        key={subTab.path}
        onClick={() => onSelect(subTab.path)}>
        {subTab.name}
      </Button>
    ))}
    <Box />
  </VStack>
)
